import ChevronDownIcon from '@atlaskit/icon/core/chevron-down';
import ChevronUpIcon from '@atlaskit/icon/core/chevron-up';
import { Box, xcss } from '@atlaskit/primitives';
import { handleKeyDown } from '../util';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const accordionHeaderCustomStyles = xcss({
  flex: 1,
  height: '100%',
  overflowX: 'hidden'
});
const accordionHeaderItemStyles = xcss({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  backgroundColor: 'elevation.surface',
  cursor: 'pointer',
  ':hover': {
    backgroundColor: 'elevation.surface.hovered'
  },
  ':active': {
    backgroundColor: 'elevation.surface.pressed'
  }
});
export const AccordionItemHeader = _ref => {
  let {
    togglePanel,
    isPanelOpen,
    renderHeader,
    ariaLabel,
    itemKey
  } = _ref;
  const handleAccordionKeyDown = event => {
    handleKeyDown(event, togglePanel);
  };
  return /*#__PURE__*/_jsxs(Box, {
    onClick: togglePanel,
    role: "button",
    tabIndex: 0,
    onKeyDown: handleAccordionKeyDown,
    xcss: accordionHeaderItemStyles,
    "aria-label": ariaLabel,
    "aria-expanded": isPanelOpen,
    "aria-controls": "content-".concat(itemKey),
    id: "header-".concat(itemKey),
    style: {
      outlineOffset: -5
    },
    children: [/*#__PURE__*/_jsx(Box, {
      xcss: accordionHeaderCustomStyles,
      children: renderHeader()
    }), /*#__PURE__*/_jsx(Box, {
      paddingInlineEnd: "space.200",
      children: isPanelOpen ? /*#__PURE__*/_jsx(ChevronUpIcon, {
        label: "Collapse",
        size: "small"
      }) : /*#__PURE__*/_jsx(ChevronDownIcon, {
        label: "Expand",
        size: "small"
      })
    })]
  });
};